export default __webpack_public_path__ + "static/media/banner-400x220-donuts.7c261fb7.jpg";